import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const BookingDotComLinkValidation = {
  hotelId: [
    customMessageValidator(
      'booking_dot_com_link_hotel_id_present',
      validatePresence({ presence: true }),
    ),

    customMessageValidator(
      'booking_dot_com_link_hotel_id_valid',
      validateFormat({ regex: /^[0-9]+$/ }),
    ),
  ],
};
